import Api from "./Api";
import Csrf from "./Csrf";

export default {   
    
  async index() {
    await Csrf.getCookie();

    return Api.get("/isolations");
  },
    
  async show(id) {
    await Csrf.getCookie();

    return Api.get("/isolations/"+id);
  },
	async ApplyRedLock(id,data) {
		await Csrf.getCookie();
		
		return Api.post("/isolations/"+id+"/apply-red-lock",data);
	},
	
	async FreeRedLock(id,data) {
		await Csrf.getCookie();
		
		return Api.post("/isolations/"+id+"/free-red-lock",data);
	},
	
	async statusUpdate(id,data) {
		await Csrf.getCookie();
		
		return Api.post("/isolations/"+id+"/status-update",data);
	},
	
	async temporaryReconnectStart(form){
		await Csrf.getCookie();
		
		return Api.post('/temporary-reconnects',form);
	},
	
	async temporaryReconnectClose(form){
		await Csrf.getCookie();
		
		return Api.post('/temporary-reconnects/close',form);
	},
	
	async temporaryReconnectReconnect(form){
		await Csrf.getCookie();
		
		return Api.post('/temporary-reconnects/reconnect',form);
	},
	
	async temporaryReconnectIsolate(form){
		await Csrf.getCookie();
		
		return Api.post('/temporary-reconnects/isolate',form);
	}
};